export type URLParameterType = 'number' | 'array' | 'string' | 'boolean' | 'encodedURLComponents';

export interface IURLParameters {
    getParameter(name: string, type?: URLParameterType): any;
    hasParameter(name: string): boolean;
}
